import { render, staticRenderFns } from "./BookArtistRequest.vue?vue&type=template&id=0143781c&scoped=true"
import script from "./BookArtistRequest.vue?vue&type=script&lang=js"
export * from "./BookArtistRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143781c",
  null
  
)

export default component.exports